import template from './tab-header.html';

export default class TabHeaderComponent {
  constructor() {
    this.template = template;
    this.controller = () => {};
    this.bindings = {
      isActive: '<',
      onSelect: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/email-notification-templates/components/email-notification-tab/components/tab-header/tab-header-component.js